// import DOMPurify from 'dompurify';
// import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React, { useState } from 'react';

import Clear from '@/assets/icons/close-normal.svg';

// import {
//   getImageUrl,
//   isSvgImage,
// } from '../../helpers/floor-plan/floor-plan-helpers';
import { brandGrey1 } from '@/helpers/tailwindColors';
import { useIsMobile } from '@/hooks/use-is-mobile';
import LinkWrapper from '../link-wrapper/link-wrapper';
import { FilterTile, MapTile } from './floor-plan-map.interface';
import Image from 'next/image';
import { useGetLibraryConstantsDictionaryData } from '@/providers/ConfigProvider';

interface BubbleData {
  imageUrl?: string;
  slug?: string;
  name?: string;
  imageDescription?: string;
  imageIsSvg?: boolean;
  imageSvgData?: string;
  description?: string;
}

interface FloorPlanInfoBubbleProps {
  activeStore?: MapTile;
  closeInformationBubble: () => Promise<void>;
  node_locale: string;
  serviceData: { [key: string]: FilterTile };
}

export const FloorPlanInfoBubble = ({
  activeStore,
  closeInformationBubble,
  node_locale,
  serviceData,
}: FloorPlanInfoBubbleProps) => {
  const dictionary = useGetLibraryConstantsDictionaryData();
  let bubbleData: BubbleData = {
    imageDescription: activeStore?.icon?.coverImage?.description,
    description: activeStore?.description,
  };

  const isMobile = useIsMobile();

  const [hoverX, setHoverX] = useState(false);
  const [hoverText, setHoverText] = useState(false);

  if (activeStore) {
    // if (
    //   isSvgImage(activeStore?.icon?.coverImage) ||
    //   isSvgImage(serviceData[activeStore.id]?.images?.coverImage)
    // ) {
    //   bubbleData = {
    //     ...bubbleData,
    //     imageIsSvg: true,
    //   };
    // }

    if (Object.keys(serviceData).includes(activeStore?.id)) {
      //Is service
      bubbleData = {
        ...bubbleData,
        name: serviceData[activeStore.id].title,
        slug: serviceData[activeStore.id].slug,
      };
      const coverImage = serviceData[activeStore.id]?.images?.coverImage;

      // if (bubbleData.imageIsSvg) {
      //   const svgContent =
      //     typeof coverImage === 'object' && coverImage?.svg?.content
      //       ? coverImage.svg.content
      //       : null;

      //   if (svgContent) {
      //     let processed = svgContent;

      //     if (bubbleData.imageDescription) {
      //       const description = isBrowser
      //         ? DOMPurify.sanitize(bubbleData.imageDescription)
      //         : bubbleData.imageDescription;
      //       processed = processed.replace(
      //         '>',
      //         `><title>${description}</title>`,
      //       );
      //     }

      //     processed = processed.replace(
      //       '<svg ',
      //       '<svg class="rounded-tl-lg overflow-hidden" ',
      //     );

      //     bubbleData.imageSvgData = processed;
      //   } else {
      //     // It's an SVG URL (not inline content) - treat as image URL
      //     bubbleData.imageUrl = getImageUrl(coverImage);
      //   }
      // } else {
      bubbleData = {
        ...bubbleData,
        imageUrl:
          coverImage && 'jsonBynderAsset' in coverImage
            ? coverImage?.jsonBynderAsset?.originalUrl
            : coverImage?.url,
      };
    } else {
      bubbleData = {
        ...bubbleData,
        name: activeStore?.name,
        slug: activeStore?.icon?.slug,
        imageUrl: activeStore?.icon?.coverImage?.url,
      };
    }
  }

  return bubbleData && Object.keys(bubbleData).length > 0 ? (
    <div
      className={`relative drop-shadow-lg ${isMobile ? '-top-[139px]' : ''} `}
    >
      <svg
        className={`absolute ${
          isMobile ? '-bottom-[9.5rem] -left-6 scale-75' : '-left-5 bottom-3'
        } `}
        xmlns="http://www.w3.org/2000/svg"
        width="92"
        height="52"
        viewBox="0 0 92 52"
        fill="none"
      >
        <path
          d="M18.5 45.5C25 13.5 16.5 0 0 0H92C75 0 70.9445 0.999755 66.5 6C58.5 15 33 40.5 27.5 45.5C22 50.5 16.2657 56.4998 18.5 45.5Z"
          fill={`${hoverText ? brandGrey1 : '#F7F4EF'}`}
        />
      </svg>
      <div
        className={`absolute ${
          isMobile ? '-top-16 scale-75' : '-top-[284px]'
        } -left-[100px]`}
      >
        <div className="h-16 w-5/6">
          <div
            onMouseOver={() => {
              setHoverX(true);
            }}
            onMouseLeave={() => {
              setHoverX(false);
            }}
            className={`absolute -right-4 -top-4 z-10 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full ${
              hoverX ? 'bg-brand-grey-2' : 'bg-brand-grey-1'
            } `}
            onClick={async () => await closeInformationBubble()}
          >
            <Clear viewBox="0 0 14 14" className="h-[10.5px] w-[10.5px]" />
          </div>

          <div
            className={`relative flex w-[200px] flex-col overflow-hidden rounded-xl bg-brand-white
            `}
          >
            <div className="flex min-h-[133px] justify-center overflow-hidden rounded-tl-lg">
              {/* {bubbleData && bubbleData.imageSvgData && (
                <div
                  className="h-[133px] w-[133px]"
                  dangerouslySetInnerHTML={{
                    __html: bubbleData.imageSvgData ?? '',
                  }}
                />
              )} */}
              {bubbleData &&
                bubbleData.imageUrl &&
                typeof bubbleData.imageUrl === 'string' &&
                bubbleData.imageUrl?.endsWith('.svg') && (
                  <Image
                    src={bubbleData.imageUrl}
                    alt={bubbleData.imageDescription ?? ''}
                    className="h-[133px] w-[133px]"
                    width={133}
                    height={133}
                  />
                )}
              {bubbleData &&
                bubbleData.imageUrl &&
                typeof bubbleData.imageUrl === 'string' &&
                !bubbleData.imageUrl?.endsWith('.svg') &&
                bubbleData.imageUrl !== null && (
                  <Image
                    alt={bubbleData.imageDescription ?? ''}
                    src={bubbleData.imageUrl}
                    width={`${200}`}
                    height={`${133}`}
                    className="h-[133px] object-cover"
                  />
                )}
            </div>
            <div
              className={`${
                hoverText
                  ? 'bg-background-secondary'
                  : 'bg-background-primary-light'
              } px-3 pb-4 pt-6 text-headings text-text-default`}
              onMouseOver={() => {
                setHoverText(true);
              }}
              onMouseLeave={() => {
                setHoverText(false);
              }}
            >
              {bubbleData.name && !bubbleData.description && (
                <div>{bubbleData.name}</div>
              )}
              <div className="mb-2 font-title">{bubbleData.description}</div>
              {bubbleData.slug && dictionary && (
                <LinkWrapper
                  data={bubbleData.slug}
                  className="font-sans text-bodym text-text-default underline underline-offset-4 lg:hover:text-neutral-grey-900"
                >
                  {dictionary.readMore}
                </LinkWrapper>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
